module.exports = require('./helpers/bundle-url').getBundleURL('7jzoL') + "logo.c51670a8.svg";